import { TermsConditions } from "../types/working-model";
import { Get } from "./helpers";

export function GetTermsConditions(terms_id: number): Promise<TermsConditions> {
	return Get(`/v3/admin/events/terms-conditions/${terms_id}`, "");
}